<template>
    <v-card>
        <v-card-text>
            <template v-if="user?.is_subscribed || user?.is_admin || $page.props.free_use">
                <template v-if="loading">
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line" />
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line" class="mt-2" />
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-two-line" class="mt-2" />
                </template>
                <template v-else>
                    <template v-if="hasEvent('TI')">
                        <h2 class="my-4">Trampoline</h2>
                        <athlete-mobility-event
                            :mobility-information="athleteMobilities.TI"
                            :athlete-id="athleteId"
                            event="TI"
                        />
                    </template>

                    <template v-if="hasEvent('DM')">
                        <h2 class="my-4">Double Mini</h2>
                        <athlete-mobility-event
                            :mobility-information="athleteMobilities.DM"
                            :athlete-id="athleteId"
                            event="DM"
                        />
                    </template>

                    <template v-if="hasEvent('TU')">
                        <h2 class="my-4">Tumbling</h2>
                        <athlete-mobility-event
                            :mobility-information="athleteMobilities.TU"
                            :athlete-id="athleteId"
                            event="TU"
                        />
                    </template>
                </template>
            </template>
            <subscription-required v-else />
        </v-card-text>
    </v-card>
</template>

<script>
import SubscriptionRequired from '@/Components/SubscriptionRequired.vue';
import User from '@/Models/User.js';
import AthleteMobilityEvent from '@/Components/AthleteMobilityEvent.vue';

export default {
    name: 'AthleteMobility',

    components: { AthleteMobilityEvent, SubscriptionRequired },

    props: {
        athleteId: {
            type: Number,
            required: true,
        },
    },

    data: () => ({
        loading: false,

        athleteMobilities: {
            TI: {},
            DM: {},
            TU: {},
        },
    }),

    computed: {
        user() {
            return User.find(this.$page.props.auth.user?.id);
        },
    },

    created() {
        this.retrieveAthleteMobility();
    },

    methods: {
        async retrieveAthleteMobility() {
            this.loading = true;

            const { data } = await axios.get(`/api/athletes/${this.athleteId}?all_mobility_information=1`);

            this.athleteMobilities = data.data.all_mobility_information;

            this.loading = false;
        },

        hasEvent(event) {
            return this.athleteMobilities[event] && Object.keys(this.athleteMobilities[event]).length > 0;
        },
    },
};
</script>

<style scoped lang="scss"></style>
